/**
 * Logo: skrížené meče v jantárovom kruhu + nápis. Meče sú tá istá ikona ako
 * akcia Útok (game-icons.net, CC BY), zafarbená cez CSS masku.
 */

export function Logo({ compact = false }: { compact?: boolean }) {
  return (
    <span className={`logo${compact ? ' logo--compact' : ''}`}>
      <span className="logo__mark" aria-hidden="true">
        <span className="logo__swords" />
      </span>
      <span className="logo__text">
        <span className="logo__name">Unmatched</span>
        <span className="logo__tag">Tactical Arena</span>
      </span>
    </span>
  );
}
